import { useState, useCallback } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { getBaseDomain } from '../utils/domain';

export interface CompanySwitchHookReturn {
  switchCompany: (companyId: number) => Promise<any>;
  isLoading: boolean;
  error: string | null;
}

export const useCompanySwitch = (): CompanySwitchHookReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const baseDomain = getBaseDomain();

  const switchCompany = useCallback(async (companyId: number) => {
    setIsLoading(true);
    setError(null);
    try {
      const userAuth =
        Cookies.get('accessToken') ||
        localStorage.getItem('auth_token') ||
        sessionStorage.getItem('auth_token');
      if (!userAuth) {
        throw new Error('No authentication token found');
      }
      const url = `https://globalapi.${baseDomain}/api/v1/company/switch/`;
      const response = await axios.post(
        url,
        { company_id: companyId },
        {
          headers: {
            Authorization: `Bearer ${userAuth}`,
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.data) {
        return response.data;
      }
      throw new Error(response.data?.error || 'Company switch failed');
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || err.message || 'Company switch failed';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, [baseDomain]);

  return { switchCompany, isLoading, error };
};

export default useCompanySwitch;

